(function () {
  var cfg = window.optimized_toggle_config || {};
  if (!cfg.enabled) return;

  // ---------- helpers ----------
  function tpl(str, vars) {
    return String(str || '')
      .replaceAll('{{save_price}}', vars.save_price)
      .replaceAll('{{save_percent}}', vars.save_percent);
  }

  function getCurrencySymbol(priceText) {
    if (!priceText) return '';
    return String(priceText).trim().match(/[^0-9.,\s]/)?.[0] || '';
  }

  function getPrice(el) {
    if (!el) return null;
    var text = (el.textContent || '').trim();

    // Match: "$29.99", "£ 29.99", "€29,99", etc.
    var match = text.match(/([^\d\s.,-])\s*([\d.,]+)/);
    if (!match) return null;
    return match[1] + match[2];
  }

  function getPriceFloat(input) {
    if (typeof input === 'number') return input;
    if (typeof input !== 'string') return NaN;

    var cleaned = input.replace(/[^\d.,-]/g, '');

    // if only one comma and no dot => treat as decimal comma
    if (cleaned.indexOf('.') === -1 && (cleaned.match(/,/g) || []).length === 1) {
      cleaned = cleaned.replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }

    return parseFloat(cleaned);
  }

  function formatSavePrice(currencySymbol, value, decimals) {
    if (!isFinite(value)) return currencySymbol + '0';
    var d = decimals === 0 ? 0 : 2;
    return currencySymbol + value.toFixed(d);
  }

  function linesToLis(lines, className) {
    var arr = String(lines || '')
      .split('\n')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    return arr
      .map(function (item, idx) {
        var liClass = (idx < 3) ? (className || '') : '';
        return '<li' + (liClass ? ' class="' + liClass + '"' : '') + '>' + escapeHtml(item) + '</li>';
      })
      .join('');
  }

  function escapeHtml(s) {
    return String(s)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  // ---------- core apply ----------
  function applyOptimizedToggle(subscription, subscriptionToggle) {
    if (!subscription || !subscriptionToggle) return;
    if (subscriptionToggle.dataset.optimizedToggleApplied === '1') return;

    var oneTimePrice = getPrice(subscription.querySelector('.subscription-toggle-purchase-buttons.onetime .add-to-cart'));
    var subPrice = getPrice(subscription.querySelector('.subscription-toggle-purchase-buttons.subscription .add-to-cart'));

    // percent highlight (if present)
    var highlightEl = subscriptionToggle.querySelector('.subscription-toggle-price .price-highlight');
    var subSavePercent = highlightEl ? getPriceFloat(highlightEl.textContent) : NaN;

    var oneTimeFloat = getPriceFloat(oneTimePrice || '');
    var subFloat = getPriceFloat(subPrice || '');

    if (!oneTimePrice || !subPrice || !isFinite(oneTimeFloat) || !isFinite(subFloat)) return;

    var currencySymbol = getCurrencySymbol(oneTimePrice);
    var diff = oneTimeFloat - subFloat;

    var decimals = parseInt(cfg.rounding, 10);
    if (isNaN(decimals)) decimals = 2;

    var savePrice = formatSavePrice(currencySymbol, diff, decimals);

    var savePercentText = isFinite(subSavePercent) ? String(subSavePercent) : '';

    // mark applied
    subscriptionToggle.dataset.optimizedToggleApplied = '1';

    // Remove old nodes if they exist (safe re-run)
    subscriptionToggle.querySelectorAll(
      '.subscription-toggle-sub-save,' +
      '.subscription-toggle-onetime-save,' +
      '.subscription-toggle-sub-subtitle,' +
      '.subscription-toggle-onetime-subtitle,' +
      '.subscription-toggle-benefits-wrap,' +
      '.subscription-toggle-save-percentage-badge,' +
      '.subscription-toggle-onetime-main-price'
    ).forEach(function (n) { n.remove(); });

    // Inject top banners
    subscriptionToggle.insertAdjacentHTML(
      'afterbegin',
      '<div class="subscription-toggle-sub-save">' +
        escapeHtml(tpl(cfg.textSave, { save_price: savePrice, save_percent: savePercentText })) +
      '</div>' +
      '<div class="subscription-toggle-onetime-save">' +
        escapeHtml(tpl(cfg.textOnetimeSave, { save_price: savePrice, save_percent: savePercentText })) +
      '</div>'
    );

    // Inject subtitles
    var notesEl = subscriptionToggle.querySelector('.subscription-toggle-notes');
    if (notesEl) {
      notesEl.insertAdjacentHTML(
        'beforebegin',
        '<div class="subscription-toggle-sub-subtitle">' +
          escapeHtml(tpl(cfg.subtitleSub, { save_price: savePrice, save_percent: savePercentText })) +
        '</div>' +
        '<div class="subscription-toggle-onetime-subtitle">' +
          escapeHtml(tpl(cfg.subtitleOnetime, { save_price: savePrice, save_percent: savePercentText })) +
        '</div>'
      );
    }

    // Inject benefits and badge and price display
    var inner = subscriptionToggle.querySelector('.subscription-toggle-inner');
    if (inner) {
      inner.insertAdjacentHTML(
        'afterend',
        '<div class="subscription-toggle-benefits-wrap">' +
          '<div class="subscription-toggle-benefits-sub-title">' + escapeHtml(cfg.benefitsTitleSub) + '</div>' +
          '<div class="subscription-toggle-benefits-onetime-title">' + escapeHtml(cfg.benefitsTitleOnetime) + '</div>' +
          '<ul class="subscription-toggle-benefits">' +
            linesToLis(cfg.benefitsLines, 'toggle') +
          '</ul>' +
        '</div>'
      );

      var h3 = inner.querySelector('div.h3');
      if (h3 && isFinite(subSavePercent)) {
        h3.insertAdjacentHTML(
          'beforeend',
          '<span class="subscription-toggle-save-percentage-badge">Save ' + escapeHtml(savePercentText) + '%</span>'
        );
      }

      // price element update
      var priceEl = inner.querySelector(':scope > .subscription-toggle-price');
      if (priceEl) {
        var interval = cfg.intervalLabel || '/month';

        priceEl.innerHTML =
          escapeHtml(subPrice) +
          '<span class="subscription-toggle-per-interval">' + escapeHtml(interval) + '</span>' +
          '<span class="subscription-toggle-onetime-price">' + escapeHtml(oneTimePrice) + '</span>';

        priceEl.insertAdjacentHTML(
          'beforebegin',
          '<p class="subscription-toggle-onetime-main-price">' + escapeHtml(oneTimePrice) + '</p>'
        );
      }
    }
  }

  // ---------- find targets (update selectors here if needed) ----------
  function findAndApply() {
    // Your original selectors
    var subscription = document.querySelector('#shop-page-top .subscription-toggle-container');
    var subscriptionToggle = document.querySelector('#shop-page-top .subscription-toggle-container .subscription-toggle-wrapper');

    // Fallback (in case some templates don’t have #shop-page-top)
    if (!subscription || !subscriptionToggle) {
      subscription = document.querySelector('.subscription-toggle-container');
      subscriptionToggle = document.querySelector('.subscription-toggle-container .subscription-toggle-wrapper');
    }

    if (subscription && subscriptionToggle) {
      applyOptimizedToggle(subscription, subscriptionToggle);
    }
  }

  // run once now
  findAndApply();

  // observe for async rendering (subscriptions widgets often render after load)
  var obs = new MutationObserver(function () {
    findAndApply();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();